import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogDateComponent } from './dialogDate.component';
import { SharedModule } from '@/shared/shared.module';

@NgModule({
  declarations: [DialogDateComponent],
  imports: [CommonModule, SharedModule],
})
export class DialogDateModule {
  
}
